module.exports = __webpack_public_path__ + "img/label_healthy_building.ec8e42ad.png";